'use client'

import Link from 'next/link'
import { Phone, Mail, MapPin, Printer } from 'lucide-react'

const CURRENT_YEAR = '2024'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">聯絡資訊</h3>
            <div className="space-y-3">
              <p className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>桃園市大園區航翔路107號3樓(3033室)</span>
              </p>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <div>
                  <p>03-3992627</p>
                  <p>03-3992624</p>
                </div>
              </div>
              <p className="flex items-center gap-2">
                <Printer className="h-4 w-4 flex-shrink-0" />
                <span>03-3992625</span>
              </p>
              <p className="flex items-center gap-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>tyc.customsbroker@hotmail.com</span>
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">快速連結</h3>
            <ul className="space-y-2">
              <li><Link href="/about" className="hover:text-white">關於我們</Link></li>
              <li><Link href="/news" className="hover:text-white">最新消息</Link></li>
              <li><Link href="/links" className="hover:text-white">友好連結</Link></li>
              <li><Link href="/vendors" className="hover:text-white">會員廠商</Link></li>
              <li><Link href="/contact" className="hover:text-white">聯絡我們</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p>&copy; {CURRENT_YEAR} 桃園市報關公會. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}